var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.tag,{tag:"tag",staticClass:"page-title"},[_c('span',{staticClass:"page-title--en"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"page-title--jp"},[_vm._v(_vm._s(_vm.subtitle))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }